import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { ChevronDown } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { OVContext } from '../../utils/OVContext';
import Button from '../Button';
import css from './CollectionFilters.module.scss';
import FiltersMobile from './FiltersMobile';
import Select from '../Select';
import SortsMobile from './SortsMobile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var sortLabel = 'Sort';

var CollectionFilters = function CollectionFilters(_ref) {
  var clearFilters = _ref.clearFilters,
      displaySort = _ref.displaySort,
      filtered = _ref.filtered,
      filters = _ref.filters,
      _filterSelect = _ref.filterSelect,
      sorts = _ref.sorts,
      sort = _ref.sort,
      _sortSelect = _ref.sortSelect,
      unpadded = _ref.unpadded;

  var _useContext = useContext(OVContext),
      mobileLarge = _useContext.mobileLarge;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      filtering = _useState2[0],
      setFiltering = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      sorting = _useState4[0],
      setSorting = _useState4[1];

  var toggleFilters = function toggleFilters() {
    setFiltering(!filtering);
    setSorting(false);
  };

  var toggleSort = function toggleSort() {
    setFiltering(false);
    setSorting(!sorting);
  };

  var onClearAll = function onClearAll() {
    setFiltering(false);
    setSorting(false);
    clearFilters();
  };

  var filterIcon = /*#__PURE__*/_jsx("div", {
    className: cc([css.icon, _defineProperty({}, css.flip, filtering)]),
    children: /*#__PURE__*/_jsx(ChevronDown, {})
  });

  var sortIcon = /*#__PURE__*/_jsx("div", {
    className: cc([css.icon, _defineProperty({}, css.flip, sorting)]),
    children: /*#__PURE__*/_jsx(ChevronDown, {})
  });

  var displayFilters = filters.length > 0;
  var numSelectedFilters = filters.filter(function (filt) {
    return filt.selected;
  }).length;
  var sortADALabel = 'Click to toggle sorting options';
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsxs("div", {
      className: cc([css.inner, _defineProperty({}, css.unpadded, unpadded)]),
      children: [/*#__PURE__*/_jsxs("ul", {
        className: css.list,
        children: [!mobileLarge && filters.map(function (filter) {
          var Component = filter.component ? filter.component : Select;
          return /*#__PURE__*/_jsx("li", {
            className: css.item,
            children: /*#__PURE__*/_jsx(Component, {
              buttonProps: {
                linkStyle: true,
                small: true
              },
              ariaLabel: "Click to toggle ".concat(filter.label.toLowerCase(), " filter options"),
              label: filter.label,
              placeholder: filter.label,
              query: filter.query,
              onChange: function onChange(_ref5) {
                var target = _ref5.target;

                _filterSelect(filter, target);
              },
              name: filter.label,
              options: filter.options,
              variables: filter.variables,
              value: filter.selected ? filter.selected.value : ''
            })
          }, filter.label);
        }), mobileLarge && displayFilters && /*#__PURE__*/_jsx("li", {
          className: css.item,
          children: /*#__PURE__*/_jsxs(Button, {
            "aria-label": "Click to toggle filter options",
            iconRight: filterIcon,
            linkStyle: true,
            onClick: toggleFilters,
            small: true,
            children: ["Filter", numSelectedFilters > 0 ? " (".concat(numSelectedFilters, ")") : '']
          })
        }), !mobileLarge && !displayFilters && /*#__PURE__*/_jsx("li", {
          "aria-hidden": "true",
          className: css.item,
          children: "\xA0"
        }), filtered && /*#__PURE__*/_jsx("li", {
          className: cc([css.item, css.bordered]),
          children: /*#__PURE__*/_jsx(Button, {
            "aria-label": "Click to clear filters",
            small: true,
            linkStyle: true,
            onClick: onClearAll,
            children: "Clear All"
          })
        })]
      }), displaySort && /*#__PURE__*/_jsxs("ul", {
        className: css.list,
        children: [!mobileLarge && /*#__PURE__*/_jsx("li", {
          className: css.item,
          children: /*#__PURE__*/_jsx(Select, {
            ariaLabel: sortADALabel,
            buttonProps: {
              linkStyle: true,
              small: true
            },
            label: sortLabel,
            placeholder: sortLabel,
            onChange: function onChange(_ref6) {
              var target = _ref6.target;

              _sortSelect(target);
            },
            name: sortLabel,
            options: sorts,
            displayLabel: sort.sort ? false : sortLabel,
            value: sort.value
          })
        }), mobileLarge && /*#__PURE__*/_jsx("li", {
          className: css.item,
          children: /*#__PURE__*/_jsx(Button, {
            "aria-label": sortADALabel,
            small: true,
            linkStyle: true,
            onClick: toggleSort,
            iconRight: sortIcon,
            children: sort.sort ? sort.label : sortLabel
          })
        })]
      })]
    }), mobileLarge && (displayFilters || displaySort) && /*#__PURE__*/_jsx("div", {
      className: cc([css.dropdown, _defineProperty({}, css.on, sorting || filtering)]),
      children: /*#__PURE__*/_jsxs("div", {
        className: css.dropdownInner,
        children: [displayFilters && /*#__PURE__*/_jsx(FiltersMobile, {
          on: filtering,
          filters: filters,
          filterSelect: function filterSelect(filter, value) {
            setFiltering(false);

            _filterSelect(filter, value);
          }
        }), displaySort && /*#__PURE__*/_jsx(SortsMobile, {
          on: sorting,
          sorts: sorts,
          sortSelect: function sortSelect(newSort) {
            setSorting(false);

            _sortSelect(newSort);
          }
        })]
      })
    })]
  });
};

CollectionFilters.defaultProps = {
  unpadded: false
};
CollectionFilters.propTypes = {
  clearFilters: PropTypes.func.isRequired,
  displaySort: PropTypes.bool.isRequired,
  filtered: PropTypes.bool.isRequired,
  filters: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  filterSelect: PropTypes.func.isRequired,
  unpadded: PropTypes.bool,
  sorts: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  sort: PropTypes.shape().isRequired,
  sortSelect: PropTypes.func.isRequired
};
export default CollectionFilters;